<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-chart-line"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<div class="page-body">

  <!-- ===================================================================== -->
  <!-- FAIXA DE INDICADORES                                                  -->
  <!-- Responde "quanto entra, quem usa e quem esta em risco". A carteira    -->
  <!-- abaixo continua respondendo "com quem falar" e nao e afetada aqui.    -->
  <!-- ===================================================================== -->
  <section class="dashboard-faixa" [class.dashboard-faixa--recolhida]="recolhida">

    <div class="dashboard-faixa__topo">
      <h2 class="dashboard-faixa__titulo">
        <i class="pi pi-gauge" aria-hidden="true"></i>
        {{ 'master.planos.dashboard.texts.titulo_faixa' | translate }}
      </h2>

      <div class="dashboard-faixa__controles">
        <app-periodo-filtro
          modo="avancado"
          [opcoes]="PRESETS_DASHBOARD"
          valorPadrao="last30"
          [persistir]="false"
          [textoExibicao]="periodoTexto"
          styleClass="dashboard-faixa__periodo"
          (periodoChanged)="onPeriodoDashboardChange($event)">
        </app-periodo-filtro>

        <button pButton type="button"
          class="p-button-text p-button-rounded dashboard-faixa__recolher"
          [attr.aria-expanded]="!recolhida"
          [attr.aria-label]="(recolhida ? 'master.planos.dashboard.texts.expandir' : 'master.planos.dashboard.texts.recolher') | translate"
          [pTooltip]="(recolhida ? 'master.planos.dashboard.texts.expandir' : 'master.planos.dashboard.texts.recolher') | translate"
          tooltipPosition="left"
          (click)="alternarRecolhida()">
          <i class="pi" [ngClass]="recolhida ? 'pi-chevron-down' : 'pi-chevron-up'" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="dashboard-faixa__corpo" *ngIf="!recolhida">

      <!-- Loading: esqueletos com a altura dos cards, para o layout nao pular -->
      <div class="dashboard-skeleton" *ngIf="dashboardEstado === 'carregando'">
        <span class="dashboard-skeleton__aviso">
          {{ 'master.planos.dashboard.texts.carregando' | translate }}
        </span>
        <div class="dashboard-cards">
          <p-skeleton height="104px" borderRadius="12px"></p-skeleton>
          <p-skeleton height="104px" borderRadius="12px"></p-skeleton>
          <p-skeleton height="104px" borderRadius="12px"></p-skeleton>
        </div>
        <div class="dashboard-cards">
          <p-skeleton height="120px" borderRadius="12px"></p-skeleton>
          <p-skeleton height="120px" borderRadius="12px"></p-skeleton>
        </div>
        <p-skeleton height="220px" borderRadius="12px"></p-skeleton>
      </div>

      <!-- Erro: inline, sem toast. A carteira abaixo continua funcionando. -->
      <div class="dashboard-erro" *ngIf="dashboardEstado === 'erro'">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span class="dashboard-erro__texto">{{ dashboardErro }}</span>
        <button pButton type="button" class="p-button-sm p-button-outlined"
          [label]="'master.planos.dashboard.texts.tentar_novamente' | translate"
          icon="pi pi-refresh"
          (click)="recarregarDashboard()">
        </button>
      </div>

      <ng-container *ngIf="dashboardEstado === 'pronto'">
        <ng-container *ngIf="dashboard as d">

          <!-- ============================================================= -->
          <!-- A · PRECISA DE CONTATO HOJE                                   -->
          <!-- Cada card usa o predicado LITERAL de um filtro da carteira:   -->
          <!-- clicar leva a exatamente as linhas que ele contou.            -->
          <!-- ============================================================= -->
          <div class="dashboard-bloco">
            <div class="dashboard-bloco__titulo">
              <span>{{ 'master.planos.dashboard.faixas.contato_hoje' | translate }}</span>
              <span class="dashboard-selo dashboard-selo--hoje">
                {{ 'master.planos.dashboard.selos.hoje' | translate }}
              </span>
            </div>

            <div class="dashboard-cards">
              <button type="button" class="dashboard-card dashboard-card--acao"
                [class.dashboard-card--ativo]="filtroPlanos === 'VENCENDO'"
                [attr.aria-pressed]="filtroPlanos === 'VENCENDO'"
                (click)="onCardCarteiraClick('VENCENDO')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.carteira.vencendo' | translate:{ dias: d.carteira.vencendoEmAte } }}
                </span>
                <span class="dashboard-card__numero">{{ d.carteira.vencendoNaJanela }}</span>
              </button>

              <button type="button" class="dashboard-card dashboard-card--acao"
                [class.dashboard-card--ativo]="filtroPlanos === 'NO_LIMITE'"
                [attr.aria-pressed]="filtroPlanos === 'NO_LIMITE'"
                (click)="onCardCarteiraClick('NO_LIMITE')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.carteira.no_limite' | translate:{ percentual: PERCENTUAL_DE_ALERTA } }}
                </span>
                <span class="dashboard-card__numero">{{ d.carteira.noLimiteDeVendas }}</span>
              </button>

              <button type="button" class="dashboard-card dashboard-card--acao"
                [class.dashboard-card--ativo]="filtroPlanos === 'EM_CARENCIA'"
                [attr.aria-pressed]="filtroPlanos === 'EM_CARENCIA'"
                (click)="onCardCarteiraClick('EM_CARENCIA')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.carteira.em_carencia' | translate }}
                </span>
                <span class="dashboard-card__numero">{{ d.carteira.emCarencia }}</span>
              </button>

              <button type="button" class="dashboard-card dashboard-card--acao"
                [class.dashboard-card--ativo]="filtroPlanos === 'VENCIDOS'"
                [attr.aria-pressed]="filtroPlanos === 'VENCIDOS'"
                (click)="onCardCarteiraClick('VENCIDOS')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.carteira.vencidas' | translate }}
                </span>
                <span class="dashboard-card__numero">{{ d.carteira.assinaturasVencidas }}</span>
              </button>
            </div>
          </div>

          <!-- ============================================================= -->
          <!-- B · RISCO                                                     -->
          <!-- Duas perguntas diferentes, dois cards. Nao existe, e nao pode -->
          <!-- existir, um "total em risco".                                 -->
          <!-- ============================================================= -->
          <div class="dashboard-bloco">
            <div class="dashboard-bloco__titulo">
              <span>{{ 'master.planos.dashboard.faixas.risco' | translate }}</span>
              <span class="dashboard-selo dashboard-selo--periodo">
                {{ 'master.planos.dashboard.selos.no_periodo' | translate }}
              </span>
            </div>

            <div class="dashboard-cards">
              <!-- RNF12 — a ajuda de L1 e o texto que impede cobrar quem esta em dia, entao
                   precisa chegar por teclado E por leitor de tela. Aqui ela NAO pode virar um
                   <button> proprio como nos outros cards: o icone esta DENTRO do <button> do
                   card, e <button> nao pode conter <button>. Por isso o tooltip mora no proprio
                   card com `tooltipEvent="focus"` (o Tab no card mostra o texto; o mouse continua
                   pegando o tooltip pelo icone, como antes) e a mesma explicacao e ligada por
                   `aria-describedby` ao paragrafo so-leitor logo abaixo dos cards. -->
              <button type="button" class="dashboard-card dashboard-card--acao dashboard-card--risco"
                (click)="onCardRiscoClick('INADIMPLENCIA')"
                [pTooltip]="'master.planos.dashboard.tooltips.ajuda_l1' | translate"
                tooltipPosition="top"
                tooltipEvent="focus"
                aria-describedby="dashboardAjudaL1">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.risco.inadimplencia_titulo' | translate }}
                  <i class="pi pi-question-circle dashboard-card__ajuda"
                    [pTooltip]="'master.planos.dashboard.tooltips.ajuda_l1' | translate"
                    tooltipPosition="top"
                    aria-hidden="true"></i>
                </span>
                <!-- Indicacao a conferir, nunca fato: a lista pode conter cliente em dia -->
                <span class="dashboard-card__conferir">
                  {{ 'master.planos.dashboard.risco.inadimplencia_conferir' | translate }}
                </span>
                <span class="dashboard-card__numero">
                  {{ d.risco.emRiscoDeInadimplencia }}
                  <small>{{ 'master.planos.dashboard.risco.empresas' | translate }}</small>
                </span>
                <span class="dashboard-card__valor">
                  {{ d.risco.valorEmRiscoDeInadimplencia | guaraniFormat }}
                </span>
                <span class="dashboard-card__sublinha">
                  {{ 'master.planos.dashboard.risco.inadimplencia_sub' | translate:{ dias: d.risco.diasSemPagar } }}
                </span>
                <span class="dashboard-card__link">
                  {{ 'master.planos.dashboard.risco.ver_lista' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </span>
              </button>

              <button type="button" class="dashboard-card dashboard-card--acao dashboard-card--risco"
                (click)="onCardRiscoClick('ABANDONO')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.risco.abandono_titulo' | translate }}
                </span>
                <span class="dashboard-card__numero">
                  {{ d.risco.emRiscoDeAbandono }}
                  <small>{{ 'master.planos.dashboard.risco.empresas' | translate }}</small>
                </span>
                <span class="dashboard-card__valor">
                  {{ d.risco.valorEmRiscoDeAbandono | guaraniFormat }}
                </span>
                <span class="dashboard-card__sublinha">
                  {{ 'master.planos.dashboard.risco.abandono_sub' | translate:{ dias: d.risco.diasSemMovimentar } }}
                </span>
                <span class="dashboard-card__link">
                  {{ 'master.planos.dashboard.risco.ver_lista' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </span>
              </button>
            </div>

            <!-- Descricao acessivel do card de L1 (aria-describedby): existe para o leitor de
                 tela, nao para a vista. -->
            <p id="dashboardAjudaL1" class="dashboard-so-leitor">
              {{ 'master.planos.dashboard.tooltips.ajuda_l1' | translate }}
            </p>

            <p class="dashboard-bloco__nota">
              {{ 'master.planos.dashboard.risco.nota_sem_total' | translate }}
            </p>
          </div>

          <!-- ============================================================= -->
          <!-- C · DINHEIRO                                                  -->
          <!-- ============================================================= -->
          <div class="dashboard-bloco">
            <div class="dashboard-bloco__titulo">
              <span>{{ 'master.planos.dashboard.faixas.dinheiro' | translate }}</span>
            </div>

            <!-- Os quatro cards de dinheiro abrem a lista por tras do numero. A ajuda mora no
                 proprio card (como na inadimplencia): <button> nao pode conter <button>. -->
            <div class="dashboard-cards">
              <!-- MRR: abre na carteira o filtro PAGAS, mesmo predicado das "ativas" do card -->
              <button type="button" class="dashboard-card dashboard-card--acao"
                [class.dashboard-card--ativo]="filtroPlanos === 'PAGAS'"
                [attr.aria-pressed]="filtroPlanos === 'PAGAS'"
                (click)="onCardCarteiraClick('PAGAS')"
                [pTooltip]="'master.planos.dashboard.tooltips.ajuda_mrr' | translate"
                tooltipPosition="top"
                tooltipEvent="focus">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.dinheiro.mrr' | translate }}
                  <i class="pi pi-question-circle dashboard-card__ajuda"
                    [pTooltip]="'master.planos.dashboard.tooltips.ajuda_mrr' | translate"
                    tooltipPosition="top"
                    aria-hidden="true"></i>
                  <span class="dashboard-selo dashboard-selo--hoje">
                    {{ 'master.planos.dashboard.selos.hoje' | translate }}
                  </span>
                </span>
                <span class="dashboard-card__valor">
                  {{ d.carteira.receitaRecorrenteMensal | guaraniFormat }}
                </span>
                <span class="dashboard-card__sublinha">
                  {{ d.carteira.assinaturasAtivas }}
                  {{ 'master.planos.dashboard.dinheiro.ativas' | translate }}
                  ·
                  {{ 'master.planos.dashboard.dinheiro.ticket_medio' | translate }}
                  {{ d.carteira.ticketMedioMensal | guaraniFormat }}
                </span>
                <span class="dashboard-card__nota">
                  {{ 'master.planos.dashboard.dinheiro.mrr_nota' | translate }}
                </span>
                <span class="dashboard-card__link">
                  {{ 'master.planos.dashboard.risco.ver_lista' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </span>
              </button>

              <button type="button" class="dashboard-card dashboard-card--acao"
                (click)="onCardCobrancaClick('RECEBIDAS')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.dinheiro.recebido' | translate }}
                  <span class="dashboard-selo dashboard-selo--periodo">
                    {{ 'master.planos.dashboard.selos.no_periodo' | translate }}
                  </span>
                </span>
                <span class="dashboard-card__valor">
                  {{ d.cobranca.recebidoNoPeriodo | guaraniFormat }}
                </span>
                <span class="dashboard-card__sublinha">
                  {{ d.cobranca.pagamentosNoPeriodo }}
                  {{ 'master.planos.dashboard.dinheiro.pagamentos' | translate }}
                </span>
                <span class="dashboard-card__link">
                  {{ 'master.planos.dashboard.risco.ver_lista' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </span>
              </button>
            </div>

            <!-- Aviso que fica ENTRE os dois pares: cobranca emitida e projecao nao se somam -->
            <div class="dashboard-bloco__divisor">
              <span>{{ 'master.planos.dashboard.dinheiro.nao_somam' | translate }}</span>
            </div>

            <div class="dashboard-cards">
              <button type="button" class="dashboard-card dashboard-card--acao"
                (click)="onCardCobrancaClick('PENDENTES')">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.dinheiro.pendente' | translate }}
                  <span class="dashboard-selo dashboard-selo--hoje">
                    {{ 'master.planos.dashboard.selos.hoje' | translate }}
                  </span>
                </span>
                <span class="dashboard-card__valor">
                  {{ d.cobranca.valorPendenteDeCobranca | guaraniFormat }}
                </span>
                <span class="dashboard-card__sublinha">
                  {{ d.cobranca.empresasComCobrancaPendente }}
                  {{ 'master.planos.dashboard.risco.empresas' | translate }}
                </span>
                <span class="dashboard-card__nota">
                  {{ 'master.planos.dashboard.dinheiro.pendente_nota' | translate }}
                </span>
                <span class="dashboard-card__link">
                  {{ 'master.planos.dashboard.risco.ver_lista' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </span>
              </button>

              <!-- Clicavel: abre na carteira o filtro RENOVACAO, que usa o MESMO predicado do
                   card — o numero de empresas aqui e o total da tabela. A ajuda mora no proprio
                   card (como na inadimplencia): <button> nao pode conter <button>. -->
              <button type="button" class="dashboard-card dashboard-card--acao"
                [class.dashboard-card--ativo]="filtroPlanos === 'RENOVACAO'"
                [attr.aria-pressed]="filtroPlanos === 'RENOVACAO'"
                (click)="onCardCarteiraClick('RENOVACAO')"
                [pTooltip]="'master.planos.dashboard.tooltips.ajuda_previsto' | translate"
                tooltipPosition="top"
                tooltipEvent="focus">
                <span class="dashboard-card__rotulo">
                  {{ 'master.planos.dashboard.dinheiro.previsto' | translate }}
                  <i class="pi pi-question-circle dashboard-card__ajuda"
                    [pTooltip]="'master.planos.dashboard.tooltips.ajuda_previsto' | translate"
                    tooltipPosition="top"
                    aria-hidden="true"></i>
                  <span class="dashboard-selo dashboard-selo--futuro">
                    {{ 'master.planos.dashboard.selos.proximos_dias' | translate:{ dias: d.carteira.vencendoEmAte } }}
                  </span>
                </span>

                <!-- Nao depende do periodo: e a mesma janela do card "vencendo" mais a carencia
                     de 5 dias, so com assinatura paga. -->
                <span class="dashboard-card__valor">
                  {{ d.cobranca.valorPrevistoDeRenovacao | guaraniFormat }}
                </span>
                <span class="dashboard-card__sublinha">
                  {{ d.cobranca.empresasAVencerNoPeriodo }}
                  {{ 'master.planos.dashboard.risco.empresas' | translate }}
                </span>
                <span class="dashboard-card__nota">
                  {{ 'master.planos.dashboard.dinheiro.previsto_nota' | translate }}
                </span>
                <span class="dashboard-card__link">
                  {{ 'master.planos.dashboard.risco.ver_lista' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </span>
              </button>
            </div>

            <!-- ----------------------------------------------------------- -->
            <!-- Bloco de vencimentos do mes: painel achatado, largura        -->
            <!-- inteira, NAO clicavel (nao ha filtro correspondente na       -->
            <!-- carteira para onde levar).                                   -->
            <!-- ----------------------------------------------------------- -->
            <div class="dashboard-bloco__divisor dashboard-bloco__divisor--forte"></div>

            <div class="dashboard-mes">
              <div class="dashboard-mes__topo">
                <span class="dashboard-mes__titulo">
                  {{ 'master.planos.dashboard.mes.titulo' | translate:{ ultimo_dia: mesUltimoDia, mes: mesNumero } }}
                  <button pButton type="button"
                    class="p-button-rounded p-button-text p-button-sm dashboard-card__ajuda"
                    icon="pi pi-question-circle"
                    [pTooltip]="'master.planos.dashboard.tooltips.ajuda_mes' | translate"
                    tooltipPosition="top"
                    tooltipEvent="both"
                    [attr.aria-label]="'master.planos.dashboard.tooltips.ajuda_mes' | translate"></button>
                </span>
                <span class="dashboard-mes__recorte">
                  {{ 'master.planos.dashboard.mes.so_pago' | translate }}
                </span>
                <span class="dashboard-selo dashboard-selo--mes">
                  {{ 'master.planos.dashboard.selos.mes_calendario' | translate }}
                </span>
              </div>

              <!-- Quantidade e valor falam do MESMO conjunto: uma linha so -->
              <p class="dashboard-mes__par">
                {{ 'master.planos.dashboard.mes.par' | translate:{
                     quantidade: d.carteira.vencimentosEsteMes,
                     valor: (d.carteira.valorVencendoEsteMes | guaraniFormat)
                   } }}
              </p>

              <p class="dashboard-mes__nota">
                <i class="pi pi-info-circle" aria-hidden="true"></i>
                {{ 'master.planos.dashboard.mes.nota' | translate:{ dias: d.carteira.vencendoEmAte } }}
              </p>
            </div>
          </div>

          <!-- ============================================================= -->
          <!-- D · RECEBIMENTOS POR MES + movimento da base                   -->
          <!-- ============================================================= -->
          <div class="dashboard-bloco">
            <div class="dashboard-bloco__titulo">
              <span>{{ 'master.planos.dashboard.faixas.recebimentos' | translate }}</span>
              <span class="dashboard-selo dashboard-selo--periodo">
                {{ 'master.planos.dashboard.selos.no_periodo' | translate }}
              </span>
            </div>

            <div class="dashboard-grafico">
              <app-master-dashboard-recebimentos-chart
                [dados]="d.cobranca.recebimentosPorMes">
              </app-master-dashboard-recebimentos-chart>
            </div>

            <!-- Dois contadores independentes. Sem saldo: entrar e sair sao fatos distintos. -->
            <div class="dashboard-contadores">
              <div class="dashboard-contadores__item">
                <span class="dashboard-contadores__rotulo">
                  {{ 'master.planos.dashboard.recebimentos.novos' | translate }}
                </span>
                <span class="dashboard-contadores__numero">{{ d.risco.novosNoPeriodo }}</span>
              </div>
              <div class="dashboard-contadores__item">
                <span class="dashboard-contadores__rotulo">
                  {{ 'master.planos.dashboard.recebimentos.perdidos' | translate }}
                </span>
                <span class="dashboard-contadores__numero">{{ d.risco.perdidosNoPeriodo }}</span>
              </div>
            </div>
          </div>

          <!-- ============================================================= -->
          <!-- E · USO DA BASE PAGA                                          -->
          <!-- ============================================================= -->
          <div class="dashboard-bloco">
            <div class="dashboard-bloco__titulo">
              <span>{{ 'master.planos.dashboard.faixas.uso' | translate }}</span>
              <span class="dashboard-selo dashboard-selo--periodo">
                {{ 'master.planos.dashboard.selos.no_periodo' | translate }}
              </span>
            </div>

            <div class="dashboard-uso">
              <div class="dashboard-card dashboard-card--leitura dashboard-uso__percentual">
                <span class="dashboard-card__numero">{{ d.uso.percentualDeEmpresasAtivas }}%</span>
                <span class="dashboard-card__sublinha">
                  {{ 'master.planos.dashboard.uso.percentual_sub' | translate }}
                </span>
                <ul class="dashboard-uso__lista">
                  <li>
                    {{ d.uso.empresasAtivasNoPeriodo }}
                    {{ 'master.planos.dashboard.uso.empresas_ativas' | translate }}
                  </li>
                  <!-- "movimentaram", nunca "acessaram": nao existe rastro de acesso -->
                  <li>
                    {{ d.uso.usuariosAtivosNoPeriodo }}
                    {{ 'master.planos.dashboard.uso.usuarios_ativos' | translate }}
                  </li>
                  <li>
                    {{ d.uso.empresasSemMovimentoNoPeriodo }}
                    {{ 'master.planos.dashboard.uso.sem_movimento' | translate }}
                  </li>
                </ul>
              </div>

              <div class="dashboard-grafico dashboard-uso__grafico">
                <app-master-dashboard-uso-chart
                  [dados]="d.uso.porTipo"
                  [totalMovimentacoes]="d.uso.movimentacoesNoPeriodo">
                </app-master-dashboard-uso-chart>
                <p class="dashboard-grafico__legenda">
                  {{ d.uso.movimentacoesNoPeriodo }}
                  {{ 'master.planos.dashboard.uso.total_movimentacoes' | translate }}
                </p>
              </div>
            </div>
          </div>

          <!-- ============================================================= -->
          <!-- Composicao da base (recolhida por padrao)                      -->
          <!-- ============================================================= -->
          <p-accordion styleClass="dashboard-composicao">
            <p-accordionTab [header]="'master.planos.dashboard.composicao.titulo' | translate">
              <div class="dashboard-cards">
                <!-- O MESMO numero da sublinha do MRR: pago, vigente e com dinheiro real -->
                <div class="dashboard-card dashboard-card--leitura">
                  <span class="dashboard-card__rotulo">
                    {{ 'master.planos.dashboard.composicao.pagas' | translate }}
                  </span>
                  <span class="dashboard-card__numero">{{ d.carteira.assinaturasAtivas }}</span>
                  <span class="dashboard-card__sublinha">
                    {{ 'master.planos.dashboard.composicao.pagas_sublinha' | translate }}
                  </span>
                </div>

                <div class="dashboard-card dashboard-card--leitura">
                  <span class="dashboard-card__rotulo">
                    {{ 'master.planos.dashboard.composicao.gratuitas' | translate }}
                  </span>
                  <span class="dashboard-card__numero">{{ d.carteira.assinaturasGratuitas }}</span>
                </div>

                <!-- `assinaturasEspeciais` NUNCA e card: e um recorte CONTIDO em cortesia -->
                <div class="dashboard-card dashboard-card--leitura">
                  <span class="dashboard-card__rotulo">
                    {{ 'master.planos.dashboard.composicao.cortesia' | translate }}
                  </span>
                  <span class="dashboard-card__numero">{{ d.carteira.assinaturasDeCortesia }}</span>
                  <span class="dashboard-card__sublinha">
                    {{ 'master.planos.dashboard.composicao.dos_quais_especiais' | translate:{ n: d.carteira.assinaturasEspeciais } }}
                  </span>
                </div>
              </div>

              <p class="dashboard-bloco__nota">
                {{ 'master.planos.dashboard.composicao.nota_sobreposicao' | translate }}
              </p>
            </p-accordionTab>
          </p-accordion>

          <!-- Procedencia: sempre os valores ECOADOS pela resposta -->
          <div class="dashboard-rodape">
            <span>
              {{ 'master.planos.dashboard.rodape.atualizado' | translate:{
                   data: (d.geradoEm | date: 'dd/MM/yyyy HH:mm'),
                   de: (d.periodoDe | date: 'dd/MM/yyyy'),
                   ate: (d.periodoAte | date: 'dd/MM/yyyy')
                 } }}
            </span>
            <span class="dashboard-rodape__aviso" *ngIf="periodoAjustado">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              {{ 'master.planos.dashboard.rodape.periodo_ajustado' | translate }}
            </span>
          </div>

        </ng-container>
      </ng-container>
    </div>
  </section>

  <!-- ===================================================================== -->
  <!-- CARTEIRA DE ASSINATURAS (bloco existente, inalterado)                  -->
  <!-- ===================================================================== -->
  <div class="table-card" #carteiraCard>
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-chart-line"></i>
      </div>
      <span class="card-header-title">{{ planosTexts.titulo }}</span>
    </div>

    <div class="card-content">
      <p class="planos-explicacao">{{ planosTexts.explicacao }}</p>

      <div class="search-bar">
        <p-iconField iconPosition="right" class="search-field">
          <p-inputIcon styleClass="pi pi-search" />
          <input pInputText type="text"
            [placeholder]="planosTexts.pesquisar"
            [(ngModel)]="filtroPlanoBusca"
            (ngModelChange)="onSearchPlanoChange($event)" />
        </p-iconField>

        <p-selectButton [options]="filtrosPlanos" optionLabel="label" optionValue="value"
          [ngModel]="filtroPlanos" (ngModelChange)="onFiltroPlanosChange($event)"
          styleClass="filtros-planos">
        </p-selectButton>

        <!--
          EIXO 2 — periodicidade. Controle SEPARADO da barra de situacao de proposito (D-FE2):
          sao dois eixos, e junta-los viraria "cinco opcoes virando dez", com a barra deixando de
          dizer o que e intersecao e o que e alternativa.
          `showClear` e o "voltar para todas" — NAO existe opcao "Todos" na lista (o valor nao
          existe no enum do backend).
          SEM `appendTo="body"`: o overlay fica dentro do componente e herda o dark theme, igual
          ao dropdown de itens-por-pagina que ja existe nesta tela.
        -->
        <p-dropdown [options]="tiposDePlano" optionLabel="label" optionValue="value"
          [ngModel]="tipoPlanoSelecionado" (ngModelChange)="onTipoPlanoChange($event)"
          [placeholder]="planosTexts.periodicidade_todas"
          [showClear]="true"
          [ariaLabel]="planosLabels.periodicidade"
          styleClass="filtro-periodicidade">
        </p-dropdown>
        <!-- Faixa do plano: mesmo padrao do dropdown de periodicidade acima -->
        <p-dropdown [options]="categoriasDePlano" optionLabel="label" optionValue="value"
          [ngModel]="categoriaSelecionada" (ngModelChange)="onCategoriaChange($event)"
          [placeholder]="planosTexts.categoria_todas"
          [showClear]="true"
          [ariaLabel]="planosLabels.categoria"
          styleClass="filtro-periodicidade">
        </p-dropdown>
      </div>

      <p-table [value]="planos" [loading]="planosLoading"
        (onSort)="onSortPlanos($any($event))"
        [sortField]="campoOrdenadoPlanos" [sortOrder]="planosAscendente ? 1 : -1"
        [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="empresaNome" style="width: 24%">
              {{ planosLabels.empresa }}<p-sortIcon [field]="'empresaNome'"></p-sortIcon>
            </th>
            <th style="width: 13%">{{ planosLabels.plano }}</th>
            <th style="width: 10%">{{ planosLabels.situacao }}</th>
            <th pSortableColumn="venceEm" style="width: 15%">
              {{ planosLabels.vence_em }}<p-sortIcon [field]="'venceEm'"></p-sortIcon>
            </th>
            <th style="width: 13%">{{ planosLabels.limite }}</th>
            <th pSortableColumn="vendasNoCiclo" style="width: 13%">
              {{ planosLabels.vendido }}<p-sortIcon [field]="'vendasNoCiclo'"></p-sortIcon>
            </th>
            <th pSortableColumn="percentualUsado" style="width: 12%">
              {{ planosLabels.uso }}<p-sortIcon [field]="'percentualUsado'"></p-sortIcon>
            </th>
            <th style="width: 8%">{{ labels.acoes }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-plano>
          <tr class="empresa-row" (click)="abrirEmpresaDoPlano(plano)">
            <td>
              <span class="empresa-nome">{{ plano.empresaNome || '-' }}</span>
              <div class="plano-subinfo">{{ plano.ruc || plano.email || '' }}</div>
            </td>
            <td>
              {{ plano.planoNome || '-' }}
              <span class="tag-negociado" *ngIf="plano.negociado">{{ planosTexts.negociado }}</span>
              <!-- Ex-assinante: a paga ja foi encerrada e hoje vale o Plan Inicial -->
              <span class="tag-negociado" *ngIf="plano.encerrada"
                [pTooltip]="planosTexts.voltou_ao_inicial_dica" tooltipPosition="top">
                {{ planosTexts.voltou_ao_inicial }}
              </span>
              <!-- P-FE1/RF07: sem esta linha o eixo novo e um filtro que NENHUMA coluna confirma -->
              <div class="plano-subinfo" *ngIf="periodicidadeDoPlano(plano) as periodicidade">
                {{ periodicidade }}
              </div>
              <div class="plano-subinfo" *ngIf="!plano.planoGratuito && (plano.valorDeCobranca ?? 0) > 0">
                {{ planosTexts.valor_renovacao }} {{ plano.valorDeCobranca | guaraniFormat }}
              </div>
            </td>
            <td>
              <span class="status-badge" [class.status-badge--ativo]="plano.vigente">
                {{ situacaoDoPlano(plano) }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="plano.especial; else vencimento">
                <span class="text-muted">{{ planosTexts.nao_vence }}</span>
              </ng-container>
              <ng-template #vencimento>
                <div class="date-cell" [class.alerta]="vencimentoEmAlerta(plano)">
                  <i class="pi pi-calendar"></i>
                  {{ plano.venceEm | date: 'dd/MM/yyyy' }}
                </div>
                <!-- Dias no lugar da conta de cabeca: e por eles que o suporte prioriza.
                     Plan Inicial nao vence (data em 3025): so a data, sem a contagem de dias. -->
                <div class="plano-subinfo" *ngIf="!plano.planoGratuito" [class.alerta]="vencimentoEmAlerta(plano)">
                  <ng-container *ngIf="(plano.diasParaVencer ?? 0) >= 0; else vencido">
                    {{ plano.diasParaVencer }} {{ planosTexts.dias }}
                  </ng-container>
                  <ng-template #vencido>
                    {{ planosTexts.vencido_ha }} {{ -(plano.diasParaVencer ?? 0) }} {{ planosTexts.dias }}
                  </ng-template>
                </div>
              </ng-template>
            </td>
            <td>
              <span *ngIf="!plano.especial">{{ plano.limiteAplicado | guaraniFormat }}</span>
              <span class="text-muted" *ngIf="plano.especial">{{ planosTexts.sem_limite }}</span>
              <!-- Vencida: quem manda e o teto do gratuito, e nao o do plano contratado -->
              <div class="plano-subinfo" *ngIf="!plano.especial && !plano.vigente">
                {{ planosTexts.limite_do_gratuito }}
              </div>
            </td>
            <td>{{ plano.vendasNoCiclo | guaraniFormat }}</td>
            <td>
              <ng-container *ngIf="!plano.especial; else semUso">
                <div class="uso-celula">
                  <span class="uso-percentual" [class.alerta]="limiteEmAlerta(plano)">
                    {{ plano.percentualUsado }}%
                  </span>
                  <p-progressBar [value]="plano.percentualUsado" [showValue]="false"
                    [styleClass]="limiteEmAlerta(plano) ? 'uso-bar uso-bar--alerta' : 'uso-bar'">
                  </p-progressBar>
                </div>
              </ng-container>
              <ng-template #semUso>
                <span class="text-muted">-</span>
              </ng-template>
            </td>
            <td class="actions" (click)="$event.stopPropagation()">
              <button pButton icon="pi pi-arrow-right"
                class="p-button-text p-button-rounded p-button-sm action-btn select-btn"
                [pTooltip]="tooltips.abrir" tooltipPosition="top"
                (click)="abrirEmpresaDoPlano(plano)">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-chart-line text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ planosTexts.nenhum }}</div>
                <!-- RF08: vazio POR CONSTRUCAO explica o porque; o resto mantem a dica de sempre -->
                <div class="text-gray-400 text-sm mt-1">
                  {{ recorteVazioPorConstrucao ? planosTexts.dica_sem_vencimento : planosTexts.dica_busca }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="8" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ planosTexts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="pagination-container">
        <div>
          <p-paginator (onPageChange)="onPlanosPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="planosFirst" [rows]="planosRows"
            [totalRecords]="planosTotal"
            [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="planosRows"
            (ngModelChange)="onPlanosRowsPerPageChange()" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ======================================================================= -->
<!-- DRILL-DOWN DE RISCO                                                      -->
<!-- A lista existe para o operador CONFERIR antes de ligar. Nenhuma acao de  -->
<!-- cobranca aqui, e nenhum destaque de "linha suspeita": o dado que        -->
<!-- desfaria o falso positivo nao e lido por esta feature.                   -->
<!-- ======================================================================= -->
<!--
  DESVIO DELIBERADO do padrao dos outros dialogos da area master (`master-cupons` usa
  `[closable]="false"`): aqui `closable` fica no DEFAULT (true) de proposito, para o Esc continuar
  fechando o drill-down. Com `showHeader=false` o X nem chega a ser renderizado, entao nao ha
  diferenca visual nenhuma — o unico efeito e o teclado.
-->
<p-dialog [(visible)]="riscoDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign risco-dialog"
  maskStyleClass="risco-dialog-mask"
  [style]="{ width: '72rem' }"
  [breakpoints]="{ '960px': '95vw' }"
  (onHide)="fecharRisco()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-users" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>
          {{ (riscoTipo === 'INADIMPLENCIA'
                ? 'master.planos.dashboard.drilldown.titulo_inadimplencia'
                : 'master.planos.dashboard.drilldown.titulo_abandono') | translate }}
        </h2>
        <p class="dialog-wave-subtitle">
          {{ 'master.planos.dashboard.drilldown.subtitulo' | translate:{ total: riscoTotal } }}
        </p>
      </div>
    </div>
    <!-- Saida sempre alcancavel: o header wave e sticky, entao este X continua na
         tela enquanto a lista rola. O botao do rodape depende de o dialog caber. -->
    <button type="button" class="dialog-wave-close"
      [attr.aria-label]="'master.planos.dashboard.drilldown.fechar' | translate"
      (click)="fecharRisco()">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">

    <!-- Aviso de falso positivo: so na aba de inadimplencia, antes da tabela -->
    <div class="risco-aviso" *ngIf="riscoTipo === 'INADIMPLENCIA'">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ 'master.planos.dashboard.drilldown.aviso_l1' | translate }}</span>
    </div>

    <div class="search-bar">
      <p-iconField iconPosition="right" class="search-field">
        <p-inputIcon styleClass="pi pi-search" />
        <input pInputText type="text"
          [placeholder]="planosTexts.pesquisar"
          [ngModel]="riscoBusca"
          (ngModelChange)="onBuscaRiscoChange($event)" />
      </p-iconField>
    </div>

    <div class="risco-aviso risco-aviso--busca" *ngIf="buscaQuebraIgualdade">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <span>{{ 'master.planos.dashboard.drilldown.aviso_busca' | translate }}</span>
    </div>

    <!-- Erro do drill-down: inline, isolado do dashboard e da carteira -->
    <div class="dashboard-erro" *ngIf="riscoEstado === 'erro'">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span class="dashboard-erro__texto">{{ riscoErro }}</span>
      <button pButton type="button" class="p-button-sm p-button-outlined"
        [label]="'master.planos.dashboard.texts.tentar_novamente' | translate"
        icon="pi pi-refresh"
        (click)="recarregarRisco()">
      </button>
    </div>

    <ng-container *ngIf="riscoEstado !== 'erro'">
      <p-table [value]="riscoLinhas" [loading]="riscoEstado === 'carregando'"
        styleClass="risco-tabela" [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'master.planos.dashboard.drilldown.colunas.empresa' | translate }}</th>
            <th class="col-opcional">{{ 'master.planos.dashboard.drilldown.colunas.plano' | translate }}</th>
            <th *ngIf="riscoTipo === 'INADIMPLENCIA'">
              {{ 'master.planos.dashboard.drilldown.colunas.venceu_em' | translate }}
            </th>
            <th *ngIf="riscoTipo === 'INADIMPLENCIA'">
              {{ 'master.planos.dashboard.drilldown.colunas.dias_vencido' | translate }}
            </th>
            <th *ngIf="riscoTipo === 'ABANDONO'">
              {{ 'master.planos.dashboard.drilldown.colunas.ultima_movimentacao' | translate }}
            </th>
            <th *ngIf="riscoTipo === 'ABANDONO'">
              {{ 'master.planos.dashboard.drilldown.colunas.dias_sem_movimentar' | translate }}
            </th>
            <th>{{ 'master.planos.dashboard.drilldown.colunas.ultimo_pagamento' | translate }}</th>
            <th class="col-opcional">{{ 'master.planos.dashboard.drilldown.colunas.telefone' | translate }}</th>
            <th>{{ 'master.planos.dashboard.drilldown.colunas.valor_mensal' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-linha>
          <tr class="empresa-row" (click)="abrirEmpresaEmRisco(linha)">
            <td>
              <span class="empresa-nome">{{ nomeDaEmpresaEmRisco(linha) }}</span>
              <div class="plano-subinfo">{{ linha.ruc || linha.email || '' }}</div>
            </td>
            <td class="col-opcional">{{ linha.planoNome || '—' }}</td>

            <!-- Colunas de conferencia da inadimplencia: nunca colapsam no responsivo -->
            <td *ngIf="riscoTipo === 'INADIMPLENCIA'">
              <span *ngIf="linha.venceuEm; else semVencimento">
                {{ linha.venceuEm | date: 'dd/MM/yyyy' }}
              </span>
              <ng-template #semVencimento>
                <span class="text-muted">{{ planosTexts.nao_vence }}</span>
              </ng-template>
            </td>
            <td *ngIf="riscoTipo === 'INADIMPLENCIA'">
              {{ linha.diasVencido != null ? linha.diasVencido : '—' }}
            </td>

            <td *ngIf="riscoTipo === 'ABANDONO'">
              <span *ngIf="linha.ultimaMovimentacaoEm; else nuncaMovimentou">
                {{ linha.ultimaMovimentacaoEm | date: 'dd/MM/yyyy' }}
              </span>
              <ng-template #nuncaMovimentou>
                <span class="text-muted">
                  {{ 'master.planos.dashboard.drilldown.nunca_movimentou' | translate }}
                </span>
              </ng-template>
            </td>
            <td *ngIf="riscoTipo === 'ABANDONO'">
              {{ linha.diasSemMovimentar != null ? linha.diasSemMovimentar : '—' }}
            </td>

            <td>
              <span *ngIf="linha.ultimoPagamentoEm; else semPagamento">
                {{ linha.ultimoPagamentoEm | date: 'dd/MM/yyyy' }}
              </span>
              <ng-template #semPagamento><span class="text-muted">—</span></ng-template>
            </td>

            <td class="col-opcional" (click)="$event.stopPropagation()">
              <a *ngIf="linha.telefone; else semTelefone" [href]="'tel:' + linha.telefone">
                {{ linha.telefone }}
              </a>
              <ng-template #semTelefone><span class="text-muted">—</span></ng-template>
            </td>

            <td>{{ linha.valorMensal | guaraniFormat }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="colunasDoDrillDown" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 2.5rem; margin-bottom: 0.75rem;"></i>
                <div class="text-gray-500">
                  {{ 'master.planos.dashboard.drilldown.vazio' | translate }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td [attr.colspan]="colunasDoDrillDown" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ planosTexts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="pagination-container">
        <p-paginator (onPageChange)="onRiscoPageChange($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="riscoFirst" [rows]="riscoSize"
          [totalRecords]="riscoTotal"
          [showFirstLastIcon]="true">
        </p-paginator>
      </div>
    </ng-container>

  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-secondary"
      [label]="'master.planos.dashboard.drilldown.fechar' | translate"
      (click)="fecharRisco()">
    </button>
  </ng-template>
</p-dialog>

<!-- ======================================================================= -->
<!-- DRILL-DOWN DE DINHEIRO                                                   -->
<!-- Um evento por linha (pagamento ou QR emitido), e nao uma empresa: a soma -->
<!-- do rodape e o valor do card. Sem paginacao — a lista e do tamanho dele.  -->
<!-- ======================================================================= -->
<p-dialog [(visible)]="cobrancaDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign risco-dialog"
  maskStyleClass="risco-dialog-mask"
  [style]="{ width: '64rem' }"
  [breakpoints]="{ '960px': '95vw' }"
  (onHide)="fecharCobrancas()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-wallet" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>
          {{ (cobrancaTipo === 'RECEBIDAS'
                ? 'master.planos.dashboard.cobrancas.titulo_recebidas'
                : 'master.planos.dashboard.cobrancas.titulo_pendentes') | translate }}
        </h2>
        <p class="dialog-wave-subtitle" *ngIf="dashboard as d">
          <ng-container *ngIf="cobrancaTipo === 'RECEBIDAS'; else subtituloPendentes">
            {{ 'master.planos.dashboard.cobrancas.subtitulo_recebidas' | translate:{
                 total: cobrancaLinhas.length,
                 de: (d.periodoDe | date: 'dd/MM/yyyy'),
                 ate: (d.periodoAte | date: 'dd/MM/yyyy')
               } }}
          </ng-container>
          <ng-template #subtituloPendentes>
            {{ 'master.planos.dashboard.cobrancas.subtitulo_pendentes' | translate:{ total: cobrancaLinhas.length } }}
          </ng-template>
        </p>
      </div>
    </div>
    <button type="button" class="dialog-wave-close"
      [attr.aria-label]="'master.planos.dashboard.drilldown.fechar' | translate"
      (click)="fecharCobrancas()">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">

    <div class="dashboard-erro" *ngIf="cobrancaEstado === 'erro'">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span class="dashboard-erro__texto">{{ cobrancaErro }}</span>
      <button pButton type="button" class="p-button-sm p-button-outlined"
        [label]="'master.planos.dashboard.texts.tentar_novamente' | translate"
        icon="pi pi-refresh"
        (click)="carregarCobrancas()">
      </button>
    </div>

    <p-table *ngIf="cobrancaEstado !== 'erro'"
      [value]="cobrancaLinhas" [loading]="cobrancaEstado === 'carregando'"
      styleClass="risco-tabela" [tableStyle]="{ 'width': '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'master.planos.dashboard.cobrancas.colunas.empresa' | translate }}</th>
          <th>
            {{ (cobrancaTipo === 'RECEBIDAS'
                  ? 'master.planos.dashboard.cobrancas.colunas.origem_recebidas'
                  : 'master.planos.dashboard.cobrancas.colunas.origem_pendentes') | translate }}
          </th>
          <th>
            {{ (cobrancaTipo === 'RECEBIDAS'
                  ? 'master.planos.dashboard.cobrancas.colunas.data_recebidas'
                  : 'master.planos.dashboard.cobrancas.colunas.data_pendentes') | translate }}
          </th>
          <th class="col-opcional">{{ 'master.planos.dashboard.cobrancas.colunas.forma' | translate }}</th>
          <th class="col-opcional">{{ 'master.planos.dashboard.cobrancas.colunas.telefone' | translate }}</th>
          <th class="text-right">{{ 'master.planos.dashboard.cobrancas.colunas.valor' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-linha>
        <tr class="empresa-row" (click)="abrirEmpresaDaCobranca(linha)">
          <td>
            <span class="empresa-nome">{{ nomeDaEmpresaDaCobranca(linha) }}</span>
            <div class="plano-subinfo">{{ linha.ruc || linha.email || '' }}</div>
          </td>
          <td>{{ origemDaCobranca(linha) }}</td>
          <td>{{ linha.data | date: 'dd/MM/yyyy' }}</td>
          <td class="col-opcional">{{ formaDePagamento(linha.tipoPagamento) }}</td>
          <td class="col-opcional" (click)="$event.stopPropagation()">
            <a *ngIf="linha.telefone; else semTelefoneCobranca" [href]="'tel:' + linha.telefone">
              {{ linha.telefone }}
            </a>
            <ng-template #semTelefoneCobranca><span class="text-muted">—</span></ng-template>
          </td>
          <td class="text-right">{{ linha.valor | guaraniFormat }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr *ngIf="cobrancaEstado === 'pronto'">
          <td colspan="3">{{ 'master.planos.dashboard.cobrancas.total' | translate }}</td>
          <td class="col-opcional" colspan="2"></td>
          <td class="text-right">{{ totalDasCobrancas | guaraniFormat }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 2.5rem; margin-bottom: 0.75rem;"></i>
              <div class="text-gray-500">
                {{ (cobrancaTipo === 'RECEBIDAS'
                      ? 'master.planos.dashboard.cobrancas.vazio_recebidas'
                      : 'master.planos.dashboard.cobrancas.vazio_pendentes') | translate }}
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td colspan="6" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ planosTexts.carregando }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-secondary"
      [label]="'master.planos.dashboard.drilldown.fechar' | translate"
      (click)="fecharCobrancas()">
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
